import app from "app.controller"

import {Form, FormInput, InputGroup} from "elemental-react16"
import queryString from "qs"
import React, {Component} from "react"
import {withRouter} from "react-router-dom"
import {Button, Input} from "semantic-ui-react"
import historyStore from "stores/historyStore"
import _ from "lodash"

@withRouter
export default class SearchBar extends Component {
	state = {
		search: ""
	}

	handleRef = (c) => {
		this.inputRef = c
	}

	focus = () => {
		this.inputRef.focus()
	}

	constructor() {
		super()
		this.textInput = React.createRef()
	}

	componentDidMount() {
		let query = queryString.parse(this.props.location.search, {ignoreQueryPrefix: true})
		if (typeof(query.q) === "string") this.setState({search: query.q})
		// this.refs.namedInput.focus()
		this.focus()
	}

	handleSearchSubmit = event => {
		let history = this.props.history
		let path    = `/search?q=${this.state.search.q}`
		history.push(path)
		event.preventDefault()
	}


	updateQuery = (search) => {
		console.log("updateQuery", search)

		let history = this.props.history
		app.search.change.dispatch({q: search})
		historyStore.setSearch(search)
		if (history.location.pathname !== "/search") {
			let path = `/search?q=${search}`
			history.push(path)
		}
	}

	throttledUpdate = _.throttle(this.updateQuery, 1000, {trailing: true, leading: false})

	handleSearchChange = event => {
		const search = event.target.value
		this.setState({search: event.target.value})
		this.throttledUpdate(search)
	}

	render() {
		return (
			<Form onSubmit={this.handleSearchSubmit}
				  className="search-bar">
				<InputGroup contiguous>
					<InputGroup.Section>
						<Button
							basic
							icon="search" />
					</InputGroup.Section>
					<Input
						ref={this.handleRef}
						style={{
							boxShadow: "none",
						}}
						type="text"
						value={this.state.search}
						onChange={this.handleSearchChange}
						placeholder="Produktsuche" />
				</InputGroup>
			</Form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Search/SearchBar.js